
document.addEventListener('DOMContentLoaded', function() {
  const tabItems = document.querySelectorAll('.tab-item');
  const tabImages = document.querySelectorAll('.tab-image');

  // Initially show only first tab’s content and image
  tabItems.forEach((item, index) => {
    const textContent = item.querySelector('.tab-content');
    if (index === 0) {
      item.classList.add('active');
      if (textContent) textContent.style.display = 'block';
      tabImages[index].classList.add('active');
    } else {
      if (textContent) textContent.style.display = 'none';
    }
  });

  tabItems.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-tab');
      const textContent = tab.querySelector('.tab-content');
      const isActive = tab.classList.contains('active');

      // Remove all active states
      tabItems.forEach(item => {
        item.classList.remove('active');
        const c = item.querySelector('.tab-content');
        if (c) c.style.display = 'none';
      });
      tabImages.forEach(img => img.classList.remove('active'));

      // If same tab clicked (collapse), open first tab
      if (isActive) {
        tabItems[0].classList.add('active');
        tabImages[0].classList.add('active');
        const firstContent = tabItems[0].querySelector('.tab-content');
        if (firstContent) firstContent.style.display = 'block';
      } else {
        // Open clicked tab
        tab.classList.add('active');
        if (textContent) textContent.style.display = 'block';
        document.querySelector('.tab-image[data-tab="' + target + '"]').classList.add('active');
      }
    });
  });
});
